import { useContext, useMemo } from "react";
import { AuthContext } from "./AuthProvider";
import { DEFAULT_ROLE, KNOWN_ROLES, ROLE_ADMIN } from "./roles";

// Narrow the reported roles to the ones this app knows, and fall back to the
// least privileged role when a user has none — an account created in the
// Console without a role should still be able to work, just not see the
// Analytics dashboard.
const normalizeRoles = (reported) => {
  const known = (reported ?? []).filter((role) => KNOWN_ROLES.includes(role));
  return known.length > 0 ? known : [DEFAULT_ROLE];
};

// What components need: who is signed in, what they may reach, and how to
// sign in and out.
export const useAuth = () => {
  const auth = useContext(AuthContext);
  const user = auth.user;

  const roles = useMemo(() => (user ? normalizeRoles(user.roles) : []), [user]);

  return {
    ...auth,
    email: user?.email ?? null,
    name: user?.name ?? null,
    roles,
    // A UI hint only. Every restricted route checks the role server-side, so
    // hiding a menu item is never the thing keeping anyone out of the data.
    isAdmin: roles.includes(ROLE_ADMIN),
  };
};
